module.exports = __webpack_public_path__ + "static/media/eiffelQuestion.0ac69700.png";